import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getCommonCodeLabel } from '../../../lib/store';
import Button from '../../Button';
import { ISpeakingDetail } from '../../../models/newSpeaking.model';

const Block = styled.div`
  .title {
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    margin: 30px;
  }

  .instruction {
    margin: 0 30px;

    & * {
      font-size: 18px;
    }

    ol {
      padding-left: 20px;
    }
  }

  .student-info {
    width: 300px;
    border: 1px solid black;
    margin: 100px auto 30px auto;
    padding: 10px;
    font-size: 16px;

    & * {
      font-size: 16px;
    }
  }

  .btn {
    font-size: 20px;
    font-weight: bold;
    border-radius: 10px;
  }
`;

interface IProps {
  data: ISpeakingDetail;
  student?: {
    memberEngName: string;
    memberName: string;
    gradeCode: string;
  };
  onNext(): void;
}

const Instruction: FC<IProps> = ({
  data,
  student,
  onNext,
}) => {
  const { t } = useTranslation();
  return (
    <Block>
      <div className="title">Instruction:</div>
      <div
        className="instruction"
        dangerouslySetInnerHTML={{ __html: data.direction }}
      />
      <div className="student-info">
        <u>Student Info</u>
        <br />
        <b>Name:</b> {student?.memberEngName ?? t('cbt.speakTest.text1')}{' '}
        {student && `(${student.memberName})`}
        <br />
        <b>Grade:</b>{' '}
        {student
          ? `${getCommonCodeLabel('SY0006', student.gradeCode || '', 'ko')}`
          : t('cbt.speakTest.text1')}
        <br />
        <b>Exam:</b> {data.examName}
        <br />
      </div>
      <div className="text-center mb-5">
        <Button
          className="btn btn-outline-secondary px-5"
          onClick={onNext}
          text="START"
        />
      </div>
    </Block>
  );
};

export default Instruction;
